import { createSlice } from '@reduxjs/toolkit';

import { getReasons, getServices, getSubServices } from './servicesActions';

const initialState = {
  loading: false,
  error: null,
  services: [],
  subServices: [],
  subServicesLoading: false,
  reasons: [],
  reasonsLoading: false,
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearSubServices: (state) => {
      state.subServices = [];
      state.reasons = [];
    },
    clearReasons: (state) => {
      state.reasons = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getServices.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = null;
        state.services = payload;
      })
      .addCase(getServices.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getSubServices.pending, (state) => {
        state.subServicesLoading = true;
        state.error = null;
        state.subServices = [];
      })
      .addCase(getSubServices.fulfilled, (state, { payload }) => {
        state.subServicesLoading = false;
        state.error = null;
        state.subServices = payload;
      })
      .addCase(getSubServices.rejected, (state, { payload }) => {
        state.subServicesLoading = false;
        state.error = payload;
      })
      .addCase(getReasons.pending, (state) => {
        state.reasonsLoading = true;
        state.error = null;
        state.reasons = [];
      })
      .addCase(getReasons.fulfilled, (state, { payload }) => {
        state.reasonsLoading = false;
        state.error = null;
        state.reasons = payload;
      })
      .addCase(getReasons.rejected, (state, { payload }) => {
        state.reasonsLoading = false;
        state.error = payload;
      });
  },
});

export const { clearSubServices, clearReasons } = servicesSlice.actions;

export const selectServices = (state) => state.services.services;
export const selectServicesLoading = (state) => state.services.loading;
export const selectSubServices = (state) => state.services.subServices;
export const selectSubServicesLoading = (state) => state.services.subServicesLoading;
export const selectReasons = (state) => state.services.reasons;
export const selectReasonsLoading = (state) => state.services.reasonsLoading;

export default servicesSlice.reducer;
